<p-dialog [(visible)]="openDialog" [modal]="true" (onHide)="closeClicked()" [style]="{width: '480px'}" [baseZIndex]="10000">
    <p-header>
        <span class="p-dialog-title">{{'vbeiWarning' | translate}}</span>
    </p-header>
        <div class="error-info" #editOrderMsg="stringFormat"
        [appStringFormat]="'vbeiEditOrderMsg' | translate">
            <span class="flex-body flex-column">
                    <span class="m-b-12">{{editOrderMsg.stringFormat.substring(0,editOrderMsg.stringFormat.lastIndexOf("{0}"))}}<strong>{{selectedOrder?.name}}</strong>
                      {{editOrderMsg.stringFormat.substring(editOrderMsg.stringFormat.lastIndexOf("{0}")+3,editOrderMsg.stringFormat.lastIndexOf("{1}"))}}
                      <strong>{{selectedOrder?.createdByName}}</strong>{{editOrderMsg.stringFormat.substring(editOrderMsg.stringFormat.lastIndexOf("{1}")+3,editOrderMsg.stringFormat.lastIndexOf("{2}"))}}
                    </span>
                    <span class="m-b-12">{{editOrderMsg.stringFormat.substring(editOrderMsg.stringFormat.lastIndexOf("{2}")+3)}}</span>
            </span>
        </div>
    <p-footer>
        <button type="button" id="continue" pButton label="{{'vbeiContinue' | translate}}" (click)="continueClicked()"></button>
        <button type="button" id="cancel" class="p-button-secondary" pButton label="{{'vbeiCancel' | translate}}" (click)="closeClicked()"></button>
    </p-footer>
  </p-dialog>